/* eslint-disable react-hooks/exhaustive-deps */
import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable, useSearchParameter } from "hooks";
import { useMemo } from "react";

import { useGetAuditAlerts } from "../apis";
import { AuditAlertsRequestParams } from "../auditLog.types";
import { AuditAlertsTab } from "../constants";

const TAB_SEARCH_PARAMETER = "tab";

const useAuditAlertsList = () => {
  const { page, sorting, setSorting, setPage } = useManageTable({
    defaultSorting: [{ id: "createdAt", desc: true }]
  });

  const [tabValue, setTabValue] = useSearchParameter(TAB_SEARCH_PARAMETER);
  const tab = (tabValue as AuditAlertsTab) || AuditAlertsTab.Unreviewed;

  const setTab = (next: AuditAlertsTab) => {
    setTabValue(next === AuditAlertsTab.Unreviewed ? null : next);
    setPage(1);
  };

  const requestParams: AuditAlertsRequestParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC",
      // Default the UI to unreviewed so unacknowledged alerts surface first.
      isAcknowledged: tab === AuditAlertsTab.All ? undefined : false
    }),
    [page, sorting, tab]
  );

  const { auditAlerts, meta, isLoading, refetch } =
    useGetAuditAlerts(requestParams);

  return {
    auditAlerts,
    totalItems: meta?.itemCount ?? 0,
    tab,
    setTab,
    page,
    setPage,
    sorting,
    setSorting,
    isLoading,
    refetchAuditAlerts: refetch
  };
};

export default useAuditAlertsList;
